import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalBody {
  header?: string;
  body: string;
  confirmBtnText: string;
  cancelBtnText: string;
}

@Component({
  selector: 'app-confirmation-component',
  templateUrl: './confirmation-component.component.html',
  styleUrls: ['./confirmation-component.component.scss'],
})
export class ConfirmationComponentComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: ModalBody
  ) {}

  ngOnInit(): void {}

  handleConfirm(value: boolean) {
    this.dialogRef.close(value);
  }
}
